(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9372],{

/***/ 37665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BV": function() { return /* binding */ markReraw; },
/* harmony export */   "NB": function() { return /* binding */ unpublishStory; },
/* harmony export */   "NI": function() { return /* binding */ setAlertNoindex; },
/* harmony export */   "To": function() { return /* binding */ markNotRaw; },
/* harmony export */   "Ui": function() { return /* binding */ fetchAuthors; },
/* harmony export */   "W3": function() { return /* binding */ publishStory; },
/* harmony export */   "Xl": function() { return /* binding */ markRaw; },
/* harmony export */   "aL": function() { return /* binding */ fetchNews; },
/* harmony export */   "mY": function() { return /* binding */ saveStory; },
/* harmony export */   "q6": function() { return /* binding */ uploadLeadImage; },
/* harmony export */   "su": function() { return /* binding */ fetchStory; },
/* harmony export */   "tt": function() { return /* binding */ newsroomError; },
/* harmony export */   "yV": function() { return /* binding */ fetchRawQueue; }
/* harmony export */ });
/* unused harmony export fetchRaws */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10092);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46979);




// Storify / Raw / Publish and the Raws archive. These call the axios instance
// directly (not getReq/postReq) so the API's error message reaches the editor,
// e.g. "Write and save a headline and a story before publishing".
var unwrap = function(res) {
    return res.data.data;
};
var newsroomError = function(err, fallback) {
    var ref, ref1;
    var message = err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message;
    if (Array.isArray(message)) return message.join(" ");
    return typeof message === "string" && message ? message : fallback;
};
var fetchStory = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/alerts/".concat(alertId, "/story"))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchStory(alertId) {
        return _ref.apply(this, arguments);
    };
}();
var saveStory = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId, story) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].put */ .ZP.put("/alerts/".concat(alertId, "/story"), story)
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function saveStory(alertId, story) {
        return _ref.apply(this, arguments);
    };
}();
// Not fileUpload: its multipart interceptor stays on after a failed request. Axios sets
// the multipart header and boundary itself for FormData.
var formData = function(fields) {
    return Object.entries(fields).reduce(function(form, param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        form.append(key, value);
        return form;
    }, new FormData());
};
var _leadImageAlt, _leadImageCaption, _leadImageCredit;
// The API checks the file and makes the 1200px copy and the crops; the story must be saved first.
var uploadLeadImage = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId, file, draft) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/alerts/".concat(alertId, "/story/lead-image"), formData({
                            image: file,
                            leadImageAlt: (_leadImageAlt = draft.leadImageAlt) !== null && _leadImageAlt !== void 0 ? _leadImageAlt : "",
                            leadImageCaption: (_leadImageCaption = draft.leadImageCaption) !== null && _leadImageCaption !== void 0 ? _leadImageCaption : "",
                            leadImageCredit: (_leadImageCredit = draft.leadImageCredit) !== null && _leadImageCredit !== void 0 ? _leadImageCredit : ""
                        }))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function uploadLeadImage(alertId, file, draft) {
        return _ref.apply(this, arguments);
    };
}();
var publishStory = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/alerts/".concat(alertId, "/story/publish"))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function publishStory(alertId) {
        return _ref.apply(this, arguments);
    };
}();
var unpublishStory = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/alerts/".concat(alertId, "/story/unpublish"))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function unpublishStory(alertId) {
        return _ref.apply(this, arguments);
    };
}();
// Out of Google (noindex,follow, off the sitemaps) or back in; the page stays live either way.
var setAlertNoindex = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId, noindex) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].put */ .ZP.put("/alerts/".concat(alertId, "/noindex"), {
                            noindex: noindex
                        })
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function setAlertNoindex(alertId, noindex) {
        return _ref.apply(this, arguments);
    };
}();
var markRaw = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        var exclusiveUntil;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    exclusiveUntil = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : null;
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/alerts/".concat(alertId, "/raw"), {
                            exclusiveUntil: exclusiveUntil
                        })
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function markRaw(alertId) {
        return _ref.apply(this, arguments);
    };
}();
// Back to the top of the Raws archive, without touching the alert's own dates.
var markReraw = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post("/alerts/".concat(alertId, "/reraw"))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function markReraw(alertId) {
        return _ref.apply(this, arguments);
    };
}();
// "Not a Raw": out of the archive if it was in it, and out of the review queue.
var markNotRaw = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(alertId) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["delete"] */ .ZP["delete"]("/alerts/".concat(alertId, "/raw"))
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function markNotRaw(alertId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchRaws = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var ref, q, tag, _page, page, _size, size, params;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, q = ref.q, tag = ref.tag, _page = ref.page, page = _page === void 0 ? 1 : _page, _size = ref.size, size = _size === void 0 ? 20 : _size;
                    params = {
                        page: page,
                        size: size
                    };
                    if (q) params.q = q;
                    if (tag) params.tags = tag;
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/raws", {
                            params: params
                        })
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchRaws() {
        return _ref.apply(this, arguments);
    };
}();
var fetchRawQueue = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var ref, _page, page, _size, size;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _page = ref.page, page = _page === void 0 ? 1 : _page, _size = ref.size, size = _size === void 0 ? 20 : _size;
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/raws/queue", {
                            params: {
                                page: page,
                                size: size
                            }
                        })
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchRawQueue() {
        return _ref.apply(this, arguments);
    };
}();
var fetchNews = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var ref, _page, page, _size, size, profile, author;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _page = ref.page, page = _page === void 0 ? 1 : _page, _size = ref.size, size = _size === void 0 ? 20 : _size, profile = ref.profile, author = ref.author;
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/news", {
                            params: {
                                page: page,
                                size: size,
                                profile: profile,
                                author: author
                            }
                        })
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchNews() {
        return _ref.apply(this, arguments);
    };
}();
var fetchAuthors = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/authors")
                    ];
                case 1:
                    return [
                        2,
                        unwrap.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    });
    return function fetchAuthors() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 30694:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ authorRole; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_news_article_schema__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72638);
/* harmony import */ var styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51495);
/* harmony import */ var styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var authorRole = function(author) {
    return !author.isOrganization && author.jobTitle ? "".concat(author.jobTitle, ", Newspage") : null;
};
// Who wrote the story, under it; on their own page (onPage) it heads the page.
var AuthorBlock = function(param) {
    var author = param.author, _onPage = param.onPage, onPage = _onPage === void 0 ? false : _onPage;
    var photo = (0,utils_news_article_schema__WEBPACK_IMPORTED_MODULE_2__/* .webUrl */ .wo)(author.photoUrl);
    var linkedin = (0,utils_news_article_schema__WEBPACK_IMPORTED_MODULE_2__/* .webUrl */ .wo)(author.linkedinUrl);
    var role = authorRole(author);
    var href = (0,utils_news_article_schema__WEBPACK_IMPORTED_MODULE_2__/* .authorPath */ .tw)(author.slug);
    var Name = onPage ? "h1" : "p";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: [
            (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_3___default().authorBlock),
            !onPage && (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_3___default().authorFoot)
        ].filter(Boolean).join(" "),
        "aria-label": onPage ? undefined : "About the author",
        children: [
            photo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                className: (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_3___default().authorPhoto),
                src: photo,
                alt: author.name,
                width: 96,
                height: 96
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Name, {
                        className: (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_3___default().authorName),
                        children: onPage ? author.name : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: href,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: author.name
                            })
                        })
                    }),
                    role && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_3___default().authorRole),
                        children: role
                    }),
                    author.bio && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_3___default().authorBio),
                        children: author.bio
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: (styles_modules_newsAlert_Newsroom_module_scss__WEBPACK_IMPORTED_MODULE_3___default().authorLinks),
                        children: [
                            !onPage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                href: href,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    children: [
                                        "More from ",
                                        author.name
                                    ]
                                })
                            }),
                            linkedin && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: linkedin,
                                target: "_blank",
                                rel: "noopener",
                                children: "LinkedIn"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AuthorBlock);


/***/ }),

/***/ 19372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "newsPageProps": function() { return /* binding */ newsPageProps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(10092);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2962);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25617);
/* harmony import */ var next_seo_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5056);
/* harmony import */ var api_newsroom__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37665);
/* harmony import */ var store__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6857);
/* harmony import */ var store_auth__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32505);
/* harmony import */ var layouts_SidebarLayout__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22028);
/* harmony import */ var components_Typo__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(23775);
/* harmony import */ var utils_seo_title__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(61055);
/* harmony import */ var utils_alert_url__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(72247);
/* harmony import */ var utils_newsroom__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(93889);
/* harmony import */ var utils_safe_html__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(95460);
/* harmony import */ var utils_news_article_schema__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(72638);
/* harmony import */ var components_Alert_Newsroom_AuthorBlock__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(30694);
/* harmony import */ var styles_modules_Raws_module_scss__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(69561);
/* harmony import */ var styles_modules_Raws_module_scss__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(styles_modules_Raws_module_scss__WEBPACK_IMPORTED_MODULE_18__);






















var PAGE_SIZE = 20;
var newsHref = function(page) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, profile = ref.profile, author = ref.author;
    var base = author ? (0,utils_news_article_schema__WEBPACK_IMPORTED_MODULE_14__/* .authorPath */ .tw)(author) : "/news";
    var query = new URLSearchParams((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, profile ? {
        profile: profile
    } : {}, page > 1 ? {
        page: page
    } : {})).toString();
    return query ? "".concat(base, "?").concat(query) : base;
};
// Every published story, newest first: the one public page that links to them
// all, so a signed-out reader or a crawler can reach each story.
var News = function(param) {
    var news = param.news, page = param.page;
    var isAuthenticated = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(store_auth__WEBPACK_IMPORTED_MODULE_8__/* .authSelector */ .aF).isAuthenticated;
    var ref;
    var items = (ref = news === null || news === void 0 ? void 0 : news.data) !== null && ref !== void 0 ? ref : [];
    var ref1;
    var totalPages = (ref1 = news === null || news === void 0 ? void 0 : news.totalPages) !== null && ref1 !== void 0 ? ref1 : 0;
    var ref2;
    // /news?profile=slug: the stories one expert is quoted in, linked from their
    // profile. Noindex, as it repeats /news; its links are still followed.
    var profile = (ref2 = news === null || news === void 0 ? void 0 : news.profile) !== null && ref2 !== void 0 ? ref2 : null;
    var ref3;
    // /authors/slug: the stories bylined to one author, under who they are.
    var author = (ref3 = news === null || news === void 0 ? void 0 : news.author) !== null && ref3 !== void 0 ? ref3 : null;
    var filter = {
        profile: profile === null || profile === void 0 ? void 0 : profile.slug,
        author: author === null || author === void 0 ? void 0 : author.slug
    };
    var heading = author ? [
        author.name,
        !author.isOrganization && author.jobTitle
    ].filter(Boolean).join(", ") : profile ? "Stories quoting ".concat(profile.name) : "Latest news";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(layouts_SidebarLayout__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        isAuthenticated: isAuthenticated,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_3__/* .NextSeo */ .PB, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, next_seo_config__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z), {
                titleTemplate: (0,utils_seo_title__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(page > 1 ? "".concat(heading, ", page ").concat(page) : heading),
                description: author ? author.bio || "Stories by ".concat(author.name, " for Newspage.") : "The latest stories from the Newspage newsroom, written from our experts' answers. Newest first.",
                canonical: "".concat("https://app.newspage.media").concat(newsHref(page, filter)),
                noindex: Boolean(profile)
            })),
            author && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: (0,utils_safe_html__WEBPACK_IMPORTED_MODULE_13__/* .jsonLd */ .oL)((0,utils_news_article_schema__WEBPACK_IMPORTED_MODULE_14__/* .authorPageSchema */ .kg)(author, "https://app.newspage.media"))
                    }
                }, "author-jsonld")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (styles_modules_Raws_module_scss__WEBPACK_IMPORTED_MODULE_18___default().wrapper),
                children: [
                    author ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (styles_modules_Raws_module_scss__WEBPACK_IMPORTED_MODULE_18___default().head),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Alert_Newsroom_AuthorBlock__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                author: author,
                                onPage: true
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                className: (styles_modules_Raws_module_scss__WEBPACK_IMPORTED_MODULE_18___default().authorStories),
                                children: [
                                    "Stories by ",
                                    author.name
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (styles_modules_Raws_module_scss__WEBPACK_IMPORTED_MODULE_18___default().head),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Typo__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                variant: "h1",
                                children: heading
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (styles_modules_Raws_module_scss__WEBPACK_IMPORTED_MODULE_18___default().intro),
                                children: profile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        "Newspage stories quoting",
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            href: "/".concat(profile.slug),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                children: profile.name
                                            })
                                        }),
                                        ". Newest first."
                                    ]
                                }) : "Stories from the Newspage newsroom. Newest first."
                            })
                        ]
                    }),
                    items.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                        className: (styles_modules_Raws_module_scss__WEBPACK_IMPORTED_MODULE_18___default().list),
                        children: items.map(function(story) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                className: (styles_modules_Raws_module_scss__WEBPACK_IMPORTED_MODULE_18___default().item),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: (styles_modules_Raws_module_scss__WEBPACK_IMPORTED_MODULE_18___default().itemMeta),
                                        children: [
                                            "By ".concat(story.byline || "Newspage", " \xb7 "),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("time", {
                                                dateTime: story.publishedAt,
                                                children: (0,utils_newsroom__WEBPACK_IMPORTED_MODULE_12__/* .formatDate */ .p6)(story.publishedAt)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: (styles_modules_Raws_module_scss__WEBPACK_IMPORTED_MODULE_18___default().itemTitle),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            href: (0,utils_alert_url__WEBPACK_IMPORTED_MODULE_19__/* .alertPath */ .E)(story.slug),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                children: story.headline
                                            })
                                        })
                                    }),
                                    story.standfirst && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: (styles_modules_Raws_module_scss__WEBPACK_IMPORTED_MODULE_18___default().excerpt),
                                        children: story.standfirst
                                    })
                                ]
                            }, story.slug);
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (styles_modules_Raws_module_scss__WEBPACK_IMPORTED_MODULE_18___default().empty),
                        children: "No stories yet."
                    }),
                    totalPages > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
                        className: (styles_modules_Raws_module_scss__WEBPACK_IMPORTED_MODULE_18___default().pager),
                        "aria-label": "Pages",
                        children: [
                            page > 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: newsHref(page - 1, filter),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    rel: "prev",
                                    children: "← Newer"
                                })
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                children: [
                                    "Page ",
                                    page,
                                    " of ",
                                    totalPages
                                ]
                            }),
                            page < totalPages ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: newsHref(page + 1, filter),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    rel: "next",
                                    children: "Older →"
                                })
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {})
                        ]
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
// The listing behind /news and /authors/[slug]; filterOf picks the stories from the query.
var newsPageProps = function(filterOf) {
    return store__WEBPACK_IMPORTED_MODULE_7__/* .wrapper.getServerSideProps */ .Y.getServerSideProps(function() {
        return function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(function(param) {
                var params, ref, page, filter, news, err, ref1;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_21__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            params = param.query;
                            page = Math.max(1, parseInt(params.page, 10) || 1);
                            filter = filterOf(params);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                (0,api_newsroom__WEBPACK_IMPORTED_MODULE_6__/* .fetchNews */ .aL)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({
                                    page: page,
                                    size: PAGE_SIZE
                                }, filter))
                            ];
                        case 2:
                            news = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            err = _state.sent();
                            // Any other failure is a 500, so a crawler never sees an empty listing as the page.
                            if ((filter.profile || filter.author) && (err === null || err === void 0 ? void 0 : (ref1 = err.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 404) {
                                return [
                                    2,
                                    {
                                        notFound: true
                                    }
                                ];
                            }
                            throw err;
                        case 4:
                            // A page past the end is not an empty listing to index.
                            if (page > 1 && !((ref = news.data) === null || ref === void 0 ? void 0 : ref.length)) {
                                return [
                                    2,
                                    {
                                        notFound: true
                                    }
                                ];
                            }
                            return [
                                2,
                                {
                                    props: {
                                        news: news,
                                        page: page
                                    }
                                }
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }();
    });
};
// No wrapper.withRedux: _app.js already provides the store.
/* harmony default export */ __webpack_exports__["default"] = (News);


/***/ }),

/***/ 72638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fv": function() { return /* binding */ expertPersons; },
/* harmony export */   "PE": function() { return /* binding */ bylineAuthor; },
/* harmony export */   "kg": function() { return /* binding */ authorPageSchema; },
/* harmony export */   "tw": function() { return /* binding */ authorPath; },
/* harmony export */   "wo": function() { return /* binding */ webUrl; },
/* harmony export */   "xO": function() { return /* binding */ storyVideos; }
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29815);
/* harmony import */ var _newsroom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93889);
/* harmony import */ var _profile_seo_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88300);
/* harmony import */ var _seo_title_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61055);







// Enough to credit every quoted expert on a busy alert without the JSON-LD
// outweighing the responses it describes.
var MAX_AUTHORS = 50;
// Same length as the page's meta description, which reads the same body.
var DESCRIPTION_MAX = 160;
// An alert is tagged with every expertise it was sent to, eighty on a busy one.
// Enough keywords to cover the topic, not the whole directory.
var MAX_KEYWORDS = 50;
var isoDateTime = function(value) {
    // `new Date(null)` is the epoch, not an invalid date — guard falsy first
    var date = value ? new Date(value) : null;
    return !date || Number.isNaN(date.getTime()) ? undefined : date.toISOString();
};
var prune = function(node) {
    return Object.fromEntries(Object.entries(node).filter(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(param, 2), value = _param[1];
        return value !== undefined && value !== "" && !(Array.isArray(value) && value.length === 0);
    }));
};
var publisher = function(host) {
    return {
        "@type": "Organization",
        name: SITE_NAME,
        url: host,
        logo: {
            "@type": "ImageObject",
            url: "".concat(host, "/newspage.png")
        }
    };
};
// The firm's social profiles, as the profile's socialNetwork row holds them:
// one column per network, empty when not set. Only absolute http(s) links are
// worth a sameAs; anything else (a handle, a stray word) would mislead.
var socialUrls = function(socialNetwork) {
    return Object.entries(socialNetwork || {}).map(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(param, 2), value = _param[1];
        return (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .clean */ .ru)(value);
    }).filter(function(value) {
        return /^https?:\/\//i.test(value);
    });
};
var unique = function(values) {
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(new Set(values.filter(Boolean)));
};
// Profiles type their website as they like: "www.example.com" is common. A
// sameAs or Organization url has to be absolute, so add the scheme or leave
// the value out.
var webUrl = function(value) {
    var text = (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .clean */ .ru)(value);
    if (/^https?:\/\//i.test(text)) {
        return text;
    }
    return /^[\w-]+(\.[\w-]+)+(\/\S*)?$/.test(text) ? "https://".concat(text) : undefined;
};
// The firm an expert speaks for, as the response card words it: "{position} at
// {employer || profile name}" (Response.js). An Organization only when there is
// a name to give it.
var firmOf = function(profile, logo) {
    var name = (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .orgOf */ .iC)(profile) || (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .clean */ .ru)(profile.name);
    return name ? prune({
        "@type": "Organization",
        name: name,
        url: webUrl(profile.website),
        logo: logo
    }) : undefined;
};
// Each response is quoted under the expert's name when one was picked, and the
// company's otherwise — the same name the alert page shows. Both link to the
// company profile, which is the only public page either has. Reads name, role,
// firm, image and social links only: the response payload carries contact
// details the schema must not.
function expertPersons(responses, host) {
    var seen = new Set();
    return (Array.isArray(responses) ? responses : []).map(function() {
        var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, expert = ref.expert, profile = ref.profile;
        var ref1, ref2;
        var name = (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .clean */ .ru)(expert === null || expert === void 0 ? void 0 : expert.name) || (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .clean */ .ru)(profile === null || profile === void 0 ? void 0 : profile.name);
        if (!name) {
            return null;
        }
        // a deactivated responder's page answers 404: named, but not linked
        var linked = !(profile === null || profile === void 0 ? void 0 : profile.deactivated);
        var slug = linked ? (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .clean */ .ru)(profile === null || profile === void 0 ? void 0 : profile.slug) : "";
        var url = slug ? "".concat(host, "/").concat(slug) : undefined;
        var logo = (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .clean */ .ru)(profile === null || profile === void 0 ? void 0 : (ref1 = profile.logo) === null || ref1 === void 0 ? void 0 : ref1.path) || undefined;
        return prune({
            "@type": "Person",
            name: name,
            url: url,
            jobTitle: (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .clean */ .ru)(expert === null || expert === void 0 ? void 0 : expert.position) || (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .clean */ .ru)(profile === null || profile === void 0 ? void 0 : profile.position),
            // the response card's picture: the expert's own, else the logo
            image: (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .clean */ .ru)(expert === null || expert === void 0 ? void 0 : (ref2 = expert.image) === null || ref2 === void 0 ? void 0 : ref2.path) || logo,
            worksFor: profile ? firmOf(profile, logo) : undefined,
            sameAs: linked ? unique([
                url
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(socialUrls(profile === null || profile === void 0 ? void 0 : profile.socialNetwork)))) : undefined
        });
    }).filter(function(person) {
        var key = person && "".concat(person.name, "|").concat(person.url);
        if (!person || seen.has(key)) {
            return false;
        }
        seen.add(key);
        return true;
    }).slice(0, MAX_AUTHORS);
}
// Editors caption a video with an italic line straight after it.
var videoCaption = function(body, id) {
    var match = new RegExp("embed/".concat(id, "[^]*?</figure>\\s*<p>\\s*<(i|em)>([^]*?)</\\1>\\s*</p>")).exec(body || "");
    return match ? (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .cleanBio */ .N5)(match[2]) : "";
};
// A VideoObject per embedded YouTube video, so the story can show as a video
// result. uploadDates are YouTube's own, by video id (utils/youtube-upload-date.js).
// Google requires uploadDate, so without YouTube's the story's last save stands
// in: the video was on the page by then. hqdefault exists for every video,
// maxresdefault not.
var storyVideos = function(body, uploadDates, param) {
    var headline = param.headline, description = param.description, savedAt = param.savedAt;
    return (0,_newsroom_js__WEBPACK_IMPORTED_MODULE_0__/* .youtubeIds */ .cN)(body).map(function(id) {
        return prune({
            "@type": "VideoObject",
            name: (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .clean */ .ru)(headline),
            description: videoCaption(body, id) || (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .clean */ .ru)(description),
            thumbnailUrl: [
                "https://i.ytimg.com/vi/".concat(id, "/hqdefault.jpg")
            ],
            uploadDate: isoDateTime(uploadDates === null || uploadDates === void 0 ? void 0 : uploadDates[id]) || isoDateTime(savedAt),
            embedUrl: "https://www.youtube.com/embed/".concat(id),
            url: "https://www.youtube.com/watch?v=".concat(id)
        });
    });
};
var authorPath = function(slug) {
    return slug ? "/authors/".concat(encodeURIComponent(slug)) : null;
};
// A story's byline as schema.org reads it: the picked author with their page,
// photo, title and LinkedIn (the Newsdesk as an Organization), a typed byline
// as a bare Person, and null when the story has neither.
function bylineAuthor(story, host) {
    var author = story === null || story === void 0 ? void 0 : story.bylineAuthor;
    var name = (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .clean */ .ru)(author === null || author === void 0 ? void 0 : author.name) || (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .clean */ .ru)(story === null || story === void 0 ? void 0 : story.byline);
    if (!name) {
        return null;
    }
    if (!author) {
        return {
            "@type": "Person",
            name: name
        };
    }
    return prune({
        "@type": author.isOrganization ? "Organization" : "Person",
        name: name,
        url: "".concat(host).concat(authorPath(author.slug)),
        image: webUrl(author.photoUrl),
        jobTitle: author.isOrganization ? undefined : (0,_profile_seo_js__WEBPACK_IMPORTED_MODULE_1__/* .clean */ .ru)(author.jobTitle),
        sameAs: unique([
            webUrl(author.linkedinUrl)
        ])
    });
}
// An author's page: Google reads ProfilePage as the page about that person.
var authorPageSchema = function(author, host) {
    return {
        "@context": "https://schema.org",
        "@type": "ProfilePage",
        mainEntity: bylineAuthor({
            bylineAuthor: author
        }, host)
    };
};
// The alert's tags (expertise) by level: the top of the tree is the sector the
// alert sits in, the master tags are its named topics, and the long tail of
// child tags is only worth a keyword.
var names = function(tags) {
    return unique(tags.map(function(tag) {
        return clean(tag === null || tag === void 0 ? void 0 : tag.name);
    }));
};
var topicsOf = function(alert) {
    var tags = Array.isArray(alert === null || alert === void 0 ? void 0 : alert.expertise) ? alert.expertise : [];
    var sections = names(tags.filter(function(tag) {
        return !(tag === null || tag === void 0 ? void 0 : tag.parentId);
    }));
    var masters = names(tags.filter(function(tag) {
        return tag === null || tag === void 0 ? void 0 : tag.isMaster;
    }));
    return {
        sections: sections,
        topics: masters.length ? masters : sections,
        keywords: names(_to_consumable_array(tags.filter(function(tag) {
            return tag === null || tag === void 0 ? void 0 : tag.isMaster;
        })).concat(_to_consumable_array(tags))).slice(0, MAX_KEYWORDS)
    };
};
function buildNewsArticleSchema(alert, responses, host) {
    var headline = clean(alert === null || alert === void 0 ? void 0 : alert.title);
    var slug = clean(alert === null || alert === void 0 ? void 0 : alert.slug);
    if (!headline || !slug) {
        return null;
    }
    var url = alertUrl(slug, host);
    // publicationDate is null on every alert today, see data/sitemapNews.mjs
    var published = isoDateTime(alert.publicationDate || alert.createdAt);
    var updated = isoDateTime(alert.updatedAt);
    var people = expertPersons(responses, host);
    var ref = topicsOf(alert), sections = ref.sections, topics = ref.topics, keywords = ref.keywords;
    // tags gone and entities decoded: JSON-LD text is not HTML
    var body = cleanBio(alert.body);
    return prune({
        "@context": "https://schema.org",
        "@type": "NewsArticle",
        headline: headline,
        description: body ? truncate(body, DESCRIPTION_MAX, true) : undefined,
        url: url,
        mainEntityOfPage: {
            "@type": "WebPage",
            "@id": url
        },
        image: [
            "".concat(host, "/newspage.png")
        ],
        datePublished: published,
        // an alert never edited has no updatedAt, and one edited before its
        // publicationDate would otherwise predate itself
        dateModified: updated && published && updated > published ? updated : published,
        author: people.length ? people : [
            publisher(host)
        ],
        publisher: publisher(host),
        // the alert's sector, its main topics, and every tag as a keyword
        articleSection: sections,
        about: topics.map(function(name) {
            return {
                "@type": "Thing",
                name: name
            };
        }),
        keywords: keywords,
        isAccessibleForFree: true
    });
}


/***/ }),

/***/ 69561:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Raws_wrapper__oJ1uV","head":"Raws_head__mAUeS","authorStories":"Raws_authorStories__2WVQQ","intro":"Raws_intro__krOhY","reviewLink":"Raws_reviewLink__yKDmz","adminSection":"Raws_adminSection__KcDt2","adminBlock":"Raws_adminBlock__D1z_n","adminTool":"Raws_adminTool__kc5sb","search":"Raws_search__i6xdv","clear":"Raws_clear__KW_XF","srOnly":"Raws_srOnly__DRhZh","count":"Raws_count__WAAX_","empty":"Raws_empty__j0D6T","error":"Raws_error__4gr7n","list":"Raws_list__ciMDF","item":"Raws_item__35M_h","reviewItem":"Raws_reviewItem__hZKE9","reviewActions":"Raws_reviewActions__82iHx","tabs":"Raws_tabs__yAUCg","coverageFields":"Raws_coverageFields__RUxA4","itemMeta":"Raws_itemMeta__Vt4x8","reraw":"Raws_reraw__nJOzN","itemSource":"Raws_itemSource__6mlk8","thin":"Raws_thin__y31qG","itemTitle":"Raws_itemTitle__aVsPX","itemTitleRan":"Raws_itemTitleRan__pNeQL","ran":"Raws_ran__uhYf1","ranLabel":"Raws_ranLabel__XgfnS","excerpt":"Raws_excerpt__BQRVb","tags":"Raws_tags__IZx_5","tagOverflow":"Raws_tagOverflow__w_e6K","tagsExpanded":"Raws_tagsExpanded__gdHJs","pager":"Raws_pager__m_zW8","bankButton":"Raws_bankButton__9pAek","bankedBefore":"Raws_bankedBefore__ruAAO","myBanks":"Raws_myBanks__3e7HR","unbank":"Raws_unbank__M3fQC","bankStats":"Raws_bankStats__p6_7V","bankStat":"Raws_bankStat__4d_rm"};

/***/ }),

/***/ 51495:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"newsroom":"Newsroom_newsroom__9yZ3C","bar":"Newsroom_bar__cLqAk","barStatus":"Newsroom_barStatus__PYyzI","ok":"Newsroom_ok__0KfAG","error":"Newsroom_error__sA_bb","label":"Newsroom_label__KaYHF","count":"Newsroom_count__pYRri","hint":"Newsroom_hint__gK51z","input":"Newsroom_input__bPtjX","textarea":"Newsroom_textarea__SPDvv","headlineInput":"Newsroom_headlineInput__yCfN_","rawPanel":"Newsroom_rawPanel__IpSIH","rawStatus":"Newsroom_rawStatus__KhRzz","thinWarning":"Newsroom_thinWarning__wensW","rawActions":"Newsroom_rawActions__o_Hcz","editor":"Newsroom_editor__B05UY","editorIntro":"Newsroom_editorIntro__IG6ur","kicker":"Newsroom_kicker__QSjTx","editorGrid":"Newsroom_editorGrid__sQ2U_","editorMain":"Newsroom_editorMain__iWEaA","editorSide":"Newsroom_editorSide__FB3em","editorActions":"Newsroom_editorActions__OyZzO","unsaved":"Newsroom_unsaved__K45Bj","seo":"Newsroom_seo__DaS_M","seoHead":"Newsroom_seoHead__RN9qH","snippet":"Newsroom_snippet__pb3Cq","snippetUrl":"Newsroom_snippetUrl__BNXN7","snippetTitle":"Newsroom_snippetTitle__XTOtj","snippetText":"Newsroom_snippetText__CA8x4","lengthBar":"Newsroom_lengthBar__eV67Z","bar-good":"Newsroom_bar-good__VmkN9","bar-ok":"Newsroom_bar-ok__t9mqZ","bar-bad":"Newsroom_bar-bad__tumxL","checkGroup":"Newsroom_checkGroup__1_AHW","checks":"Newsroom_checks__d47gw","dot":"Newsroom_dot__SdO9g","dot-good":"Newsroom_dot-good__b6BHh","dot-ok":"Newsroom_dot-ok__A5GfH","dot-bad":"Newsroom_dot-bad__bCw_F","dot-info":"Newsroom_dot-info__J3UZR","story":"Newsroom_story__LYIUP","storySponsor":"Newsroom_storySponsor__UJ63r","storySponsorLabel":"Newsroom_storySponsorLabel__AVLaK","storyBody":"Newsroom_storyBody__Ed4Xw","storyHeadline":"Newsroom_storyHeadline__azLB4","storyMetaRow":"Newsroom_storyMetaRow__0ScrT","copyStory":"Newsroom_copyStory__mAyLS","storyMeta":"Newsroom_storyMeta__w_bKO","leadImage":"Newsroom_leadImage__H5z4z","bylinePhoto":"Newsroom_bylinePhoto__7rOP7","authorBlock":"Newsroom_authorBlock__3Hrhr","authorFoot":"Newsroom_authorFoot__jOeXF","authorPhoto":"Newsroom_authorPhoto__fBFSu","authorName":"Newsroom_authorName__Q25x5","authorRole":"Newsroom_authorRole__NyObG","authorBio":"Newsroom_authorBio__qjP_I","authorLinks":"Newsroom_authorLinks__38LFc","rawDivider":"Newsroom_rawDivider__yNnbE","reportedBy":"Newsroom_reportedBy__8wQ_6","related":"Newsroom_related__AT9h1","sourceCredit":"Newsroom_sourceCredit__SWZU_","sourceReminder":"Newsroom_sourceReminder__ch5bL","rawBadge":"Newsroom_rawBadge__uASw6","suggestedLink":"Newsroom_suggestedLink__fSHZK","rerawMarker":"Newsroom_rerawMarker__1R_f_","faqOffer":"Newsroom_faqOffer__Mtn2Q","leadImagePreview":"Newsroom_leadImagePreview__YWYc3","leadImageActions":"Newsroom_leadImageActions__QaJ6P","checkboxLabel":"Newsroom_checkboxLabel__bFPS8","faqStatus":"Newsroom_faqStatus__zDRDF","faqQuestion":"Newsroom_faqQuestion__KS56h","expertAnswers":"Newsroom_expertAnswers__G4S0W","sponsoredLabel":"Newsroom_sponsoredLabel__mMaml","expertAnswersHeading":"Newsroom_expertAnswersHeading__MNNbP","expertAnswersIntro":"Newsroom_expertAnswersIntro__m0oOz","expertAnswer":"Newsroom_expertAnswer__KeSn3","expertAnswersNote":"Newsroom_expertAnswersNote__0N6Xm","faqReview":"Newsroom_faqReview__OV32g","overLimit":"Newsroom_overLimit__KrelQ","topics":"Newsroom_topics__qTp5b","topicList":"Newsroom_topicList__Yk6m9","topicGroup":"Newsroom_topicGroup__BY49t","topicNoPage":"Newsroom_topicNoPage__wWDjg","linkButton":"Newsroom_linkButton___L7m_","topicActions":"Newsroom_topicActions__bNHcl"};

/***/ })

}]);